/* eslint-disable max-lines */
import * as React from "react";
import { Label } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { allowedToRemoveAppointment } from "../model";

import { RebookButton } from "./RebookButton";
import { BookAppointmentButton } from "./BookAppointmentButton";
import { TaskActionButton } from "./TaskActionButton";
import { ActionBbvTaskButton } from "./closeTaskAndCreateFollowUpTask/ActionBbvTaskButton";
import { ActionGeneralTaskButton } from "./closeTaskAndCreateFollowUpTask/ActionGeneralTaskButton";
import { AdminApproveReferralReportButton } from "./adminApproveReferralReport/AdminApproveReferralReportButton";
import { ChaseImmunisationBloodTestResultButton } from "./chaseImmunisationBloodTestResult/ChaseImmunisationBloodTestResultButton";
import { ReviewBloodTestResultButton } from "./reviewBloodTestResult/ReviewBloodTestResultButton";
import { ViewBloodTestResultEvidenceButton } from "./ViewBloodTestResultEvidenceButton";
import { ViewImmunisationCaseButton } from "./ViewImmunisationCaseButton";
import { ReviewHealthSurveillanceResultsButton } from "./reviewHealthSurveillanceResults/ReviewHealthSurveillanceResultsButton";
import { SendHealthSurveillanceQuestionnaireButton } from "./SendHealthSurveillanceQuestionnaireButton";
import { CreateRecallButton } from "./createMedicalRecall/CreateRecallButton";
import { ViewImmunisationClearanceCertificateButton } from "./ViewImmunisationClearanceCertificateButton";
import { AdminApprovePhysiotherapyReferralReportButton } from "./adminApprovePhysiotherapyReferralReport/AdminApprovePhysiotherapyReferralReportButton";
import { AmendReferralReportButton } from "./amendReferralReport/AmendReferralReportButton";
import { AmendPhysiotherapyReferralReportButton } from "./amendPhysiotherapyReferralReport/AmendPhysiotherapyReferralReportButton";
import { ManagerFeedbackOnReportButton } from "./managerFeedbackOnReport/ManagerFeedbackOnReportButton";
import { CompleteCreateVideoConsultationButton } from "./completeCreateVideoConsultation/CompleteCreateVideoConsultationButton";
import { ActionFurtherInformationAndReviewOfFitnessButton } from "./furtherInformationAndReviewOfFitness/ActionFurtherInformationAndReviewOfFitnessButton";
import { ViewEmployeeSatisfactionSurveyButton } from "./ViewEmployeeSatisfactionSurveyButton";
import { ManagerSatisfactionFollowUpQuestionnaireButton } from "./managerSatisfactionFollowUpQuestionnaire/ManagerSatisfactionFollowUpQuestionnaireButton";
import { AmendMHPTreatmentReportButton } from "./amendMHPTreatmentReport/AmendMHPTreatmentReportButton";
import { AdminReviewMHPTreatmentReportButton } from "./adminReviewMHPTreatmentReport/AdminReviewMHPTreatmentReportButton";
import {
    ViewAllImmsCompletedForRoleCertificateButton
} from "./ViewAllImmsCompletedForRoleCertificateButton";
import { WriteToGeneralPractitionerSpecialistButton } from "./generalPractitionerSpecialist/WriteToGeneralPractitionerSpecialistButton";
import { SendLetterToGeneralPractitionerSpecialistButton } from "./generalPractitionerSpecialist/SendLetterToGeneralPractitionerSpecialistButton";
import { QAAmendReferralReportButton } from "./amendReferralReport/QAAmendReferralReportButton";
import { QAAmendMHPTreatmentReportButton } from "./amendMHPTreatmentReport/QAAmendMHPTreatmentReportButton";
import { QAAmendPhysiotherapyReferralReportButton } from "./amendPhysiotherapyReferralReport/QAAmendPhysiotherapyReferralReportButton";
import { RequestReportEditButton } from "./requestReportEditButton";
import { AdminReviewPpqCertificateButton } from "./adminReviewPpqCertificate/AdminReviewPpqCertificateButton";

const StartBbvConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Clinical Notes" : "Start BBV Consultation"}
            taskRoute="bbvConsultation"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartImmunisationVaccinationConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Vaccination Consultation" : "Start Vaccination Consultation"}
            taskRoute="immunisationVaccinationConsultationNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartBbvVaccinationConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Consultation" : "Start Consultation"}
            taskRoute="bbvVaccinationConsultationNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartReferralClinicalNotes = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed || task.cancelled ? "View Clinical Notes" : "Start Consultation"}
            taskRoute="referralClinicalNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
            allowActionWhenCancelled={ true }
        />
    );
};

const StartPpqClinicalNotes = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Clinical Notes" : "Start Consultation"}
            taskRoute="ppqClinicalNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const AmendPpqCertificate = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Clinical Notes" : "Amend Certificate"}
            taskRoute="amendPpqClinicalNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartReferralReport = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Referral Report`}
            taskRoute="referralReport"
        />
    );
};

const StartReferralReportEdit = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Edit"} Referral Report`}
            taskRoute="editReferralReport"
        />
    );
};

const StartImmunisationBloodTestConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Blood Test Consultation`}
            taskRoute="immunisationBloodTestConsultation"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartBbvBloodTestConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Consultation`}
            taskRoute="bbvBloodTestConsultation"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartMHPTreatmentConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Consultation`}
            taskRoute="mhpTreatmentConsultation"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartMHPTreatmentReport = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} MHP Treatment Report`}
            taskRoute="mhpTreatmentReport"
        />
    );
};

const Rebook = (task: TaskModel, customerId: string, preventNavigation?: boolean, delegate?: (taskId: string) => void) => {
    return <RebookButton task={task} customerId={customerId} delegate={delegate} preventNavigation={preventNavigation} />;
};

const AmendReferralReport = (task: TaskModel, customerId: string) => {
    return <AmendReferralReportButton task={task} customerId={customerId} />;
};

const AmendPhysiotherapyReferralReport = (task: TaskModel, customerId: string) => {
    return <AmendPhysiotherapyReferralReportButton task={task} customerId={customerId} />;
};

const AmendMHPTreatmentReport = (task: TaskModel, customerId: string) => {
    return <AmendMHPTreatmentReportButton task={task} customerId={customerId} />;
};

const QAAmendMHPTreatmentReport = (task: TaskModel, customerId: string) => {
    return <QAAmendMHPTreatmentReportButton task={task} customerId={customerId} />;
};

const QAAmendReferralReport = (task: TaskModel, customerId: string) => {
    return <QAAmendReferralReportButton task={task} customerId={customerId} />;
};

const QAAmendPhysiotherapyReferralReport = (task: TaskModel, customerId: string) => {
    return <QAAmendPhysiotherapyReferralReportButton task={task} customerId={customerId} />;
};

const ViewPpqReport = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content="View Report"
            taskRoute="view-ppq-report"
        />
    );
};

const BookAppointment = (task: TaskModel, customerId: string) => {
    return <BookAppointmentButton task={task} customerId={customerId} />;
};

const StartBbvReport = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} BBV Report`}
            taskRoute="bbvReport"
        />
    );
};

const StartImmunisationReview = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Review`}
            taskRoute="immunisationReview"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const ActionBbvTask = (task: TaskModel) => (
    <ActionBbvTaskButton task={task} />
);

const ActionGeneralTask = (task: TaskModel) => (
    <ActionGeneralTaskButton task={task} />
);

const EmployeeCompleteHealthSurveillanceQuestionnaire = (task: TaskModel, customerId: string) => (
    <TaskActionButton
        task={task}
        customerId={customerId}
        content={`${task.completed ? "View completed" : "Start"} Health Surveillance Questionnaire`}
        taskRoute="healthSurveillanceQuestionnaire"
    />
);

const StartHealthSurveillanceConsultation = (task: TaskModel, customerId: string) => (
    <TaskActionButton
        task={task}
        customerId={customerId}
        content={`${task.completed ? "View completed" : "Start"} Health Surveillance Consultation`}
        taskRoute="healthSurveillanceConsultation"
        onConfirmation={allowedToRemoveAppointment(task)}
    />
);

const AdminApproveReferralReport = (task: TaskModel, customerId: string) => (
    <AdminApproveReferralReportButton task={task} customerId={customerId} />
);

const AdminApprovePhysiotherapyReferralReport = (task: TaskModel, customerId: string) => (
    <AdminApprovePhysiotherapyReferralReportButton task={task} customerId={customerId} />
);

const AdminReviewPpqCertificate = (task: TaskModel, customerId: string) => (
    <AdminReviewPpqCertificateButton task={task} customerId={customerId} />
);

const AdminReviewMHPTreatmentReport = (task: TaskModel, customerId: string) => (
    <AdminReviewMHPTreatmentReportButton task={task} customerId={customerId} />
);

const ChaseImmunisationBloodTestResult = (task: TaskModel) => (
    <ChaseImmunisationBloodTestResultButton task={task} />
);

const ReviewBloodTestResult = (task: TaskModel) => (
    <ReviewBloodTestResultButton task={task} />
);

const ViewBloodTestResultEvidence = (task: TaskModel) => (
    <ViewBloodTestResultEvidenceButton task={task} />
);

const ViewImmunisationCase = (task: TaskModel) => (
    <ViewImmunisationCaseButton task={task} />
);

const ViewAllImmunisationsCompletedForRoleCertificate = (task: TaskModel) => (
    <ViewAllImmsCompletedForRoleCertificateButton task={task} />
);

const ViewImmunisationClearanceCertificate = (task: TaskModel) => (
    <ViewImmunisationClearanceCertificateButton task={task} />
);

const ReviewHealthSurveillanceResults = (task: TaskModel) => (
    <ReviewHealthSurveillanceResultsButton task={task} />
);

const SendHealthSurveillanceQuestionnaire = (task: TaskModel) => (
    <SendHealthSurveillanceQuestionnaireButton task={task} />
);

const StartHealthSurveillanceClinicalNotes = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Clinical Notes" : "Start Consultation"}
            taskRoute="healthSurveillanceClinicalNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const ViewHealthSurveillanceCertificate = (task: TaskModel, customerId: string) => (
    <TaskActionButton
        task={task}
        customerId={customerId}
        content="View Certificate"
        taskRoute="healthSurveillanceCertificate"
    />
);

const CreateRecall = (task: TaskModel) => (
    <CreateRecallButton task={task} />
);

const ReviewPpqDeclaration = (task: TaskModel, customerId: string) => (
    <TaskActionButton
        task={task}
        customerId={customerId}
        content={`${task.completed ? "View PPQ Declaration Review" : "Review PPQ Declaration"}`}
        taskRoute="ppqDeclarationReview"
    />
);

const StartGenericCaseClinicalNotes = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={task.completed ? "View Clinical Notes" : "Start Consultation"}
            taskRoute="genericCaseClinicalNotes"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartPhysiotherapyAssessmentConsultation = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View completed" : "Start"} Physiotherapy Assessment Consultation`}
            taskRoute="physiotherapyAssessmentConsultation"
            onConfirmation={allowedToRemoveAppointment(task)}
        />
    );
};

const StartPhysiotherapyReferralReport = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={`${task.completed ? "View" : "Start"} Physiotherapy Referral Report`}
            taskRoute="physiotherapyReferralReport"
        />
    );
};

const ManagerFeedbackOnReport = (task: TaskModel, customerId: string) => {
    return <ManagerFeedbackOnReportButton task={task} customerId={customerId} />;
};

const CompleteCreateVideoConsultation = (task: TaskModel, customerId: string) => {
    return <CompleteCreateVideoConsultationButton task={task} customerId={customerId} />;
};

const StartHavsClinicalAssessmentOfHistoryAndExamination = (task: TaskModel, customerId: string) => (
    <TaskActionButton
        task={task}
        customerId={customerId}
        content={`${task.completed ? "View completed" : "Start"} HAVS Clinical Assessment of History and Examination`}
        taskRoute="havsClinicalAssessmentOfHistoryAndExamination"
        onConfirmation={allowedToRemoveAppointment(task)}
    />
);

const ViewFastTrackPitPupMedicalForm = (task: TaskModel, customerId: string) => (
    task.completed ?
        (<TaskActionButton
            task={task}
            customerId={customerId}
            content="View completed Fast Track Pit/Pup Medical Form"
            taskRoute="fastTrackPitPupMedicalForm"
        />)
        : (<Label></Label>)
);

const ActionFurtherInformationAndReviewOfFitness = (task: TaskModel) => (
    <ActionFurtherInformationAndReviewOfFitnessButton task={task} />
);

const ViewEmployeeSatisfactionSurvey = (task: TaskModel) => (
    <ViewEmployeeSatisfactionSurveyButton task={task} />
);

const ManagerSatisfactionFollowUpQuestionnaire = (task: TaskModel, customerId: string) => (
    <ManagerSatisfactionFollowUpQuestionnaireButton task={task} customerId={customerId} />
);

const IaptViewCompletedQuestionnaire = (task: TaskModel, customerId: string) => {
    return (
        <TaskActionButton
            task={task}
            customerId={customerId}
            content={"View"}
            taskRoute="iaptViewCompletedQuestionnaire"
        />
    );
};

const WriteToGeneralPractitionerSpecialist = (task: TaskModel) => (
    <WriteToGeneralPractitionerSpecialistButton task={task} />
);

const SendLetterToGeneralPractitionerSpecialist = (task: TaskModel) => (
    <SendLetterToGeneralPractitionerSpecialistButton task={task} />
);

const RequestReferralReportEdit = (task: TaskModel) => (
    <RequestReportEditButton task={task} />
);

export const OtherActionTasks = [
    "AmendReferralReport",
    "AmendPhysiotherapyReferralReport",
    "AmendMHPTreatmentReport",
    "BookAppointment",
    "ActionBbvTask",
    "ActionGeneralTask",
    "EmployeeCompleteHealthSurveillanceQuestionnaire",
    "AdminApproveReferralReport",
    "AdminReviewPpqCertificate",
    "AdminApprovePhysiotherapyReferralReport",
    "ChaseImmunisationBloodTestResult",
    "SendHealthSurveillanceQuestionnaire",
    "ManagerFeedbackOnReport",
    "CompleteCreateVideoConsultation",
    "ActionFurtherInformationAndReviewOfFitness",
    "ManagerSatisfactionFollowUpQuestionnaire",
    "WriteToGeneralPractitionerSpecialist",
    "SendLetterToGeneralPractitionerSpecialist"
];

export const taskActions: { [key: string]:
        (task: TaskModel, customerId: string, preventNavigation?: boolean, delegate?: (taskId: string) => void) => React.JSX.Element; } = {
            StartBbvConsultation,
            StartImmunisationVaccinationConsultation,
            StartBbvVaccinationConsultation,
            StartReferralClinicalNotes,
            StartPpqClinicalNotes,
            AmendPpqCertificate,
            StartImmunisationBloodTestConsultation,
            StartBbvBloodTestConsultation,
            StartMHPTreatmentConsultation,
            StartMHPTreatmentReport,
            StartReferralReport,
            StartReferralReportEdit,
            Rebook,
            AmendReferralReport,
            AmendPhysiotherapyReferralReport,
            AmendMHPTreatmentReport,
            QAAmendReferralReport,
            QAAmendPhysiotherapyReferralReport,
            QAAmendMHPTreatmentReport,
            ManagerViewPpqReport: ViewPpqReport,
            EmployeeViewPpqReport: ViewPpqReport,
            BookAppointment,
            StartBbvReport,
            StartImmunisationReview,
            ActionBbvTask,
            ActionGeneralTask,
            EmployeeCompleteHealthSurveillanceQuestionnaire,
            StartHealthSurveillanceConsultation,
            AdminApproveReferralReport,
            AdminReviewPpqCertificate,
            AdminApprovePhysiotherapyReferralReport,
            AdminReviewMHPTreatmentReport,
            ChaseImmunisationBloodTestResult,
            ReviewBloodTestResult,
            ViewAllImmunisationsCompletedForRoleCertificate,
            ViewBloodTestResultEvidence,
            ViewImmunisationCase,
            ViewImmunisationClearanceCertificate,
            ReviewHealthSurveillanceResults,
            SendHealthSurveillanceQuestionnaire,
            StartHealthSurveillanceClinicalNotes,
            ViewHealthSurveillanceCertificate,
            CreateRecall,
            ReviewPpqDeclaration,
            StartGenericCaseClinicalNotes,
            StartPhysiotherapyAssessmentConsultation,
            StartPhysiotherapyReferralReport,
            ManagerFeedbackOnReport,
            CompleteCreateVideoConsultation,
            StartHavsClinicalAssessmentOfHistoryAndExamination,
            ViewFastTrackPitPupMedicalForm,
            ActionFurtherInformationAndReviewOfFitness,
            ViewEmployeeSatisfactionSurvey,
            ManagerSatisfactionFollowUpQuestionnaire,
            IaptViewCompletedQuestionnaire,
            WriteToGeneralPractitionerSpecialist,
            SendLetterToGeneralPractitionerSpecialist
        };

export const secondaryTaskActions: {
    [key: string]: (task: TaskModel, customerId: string, preventNavigation?: boolean, delegate?: (taskId: string) => void) => React.JSX.Element; } = {
        RequestReferralReportEdit,
    };
